export default __webpack_public_path__ + "static/media/remos-signal.a1426457.png";